/**
 * onCourse Billing API
 * An API for interacting with the Billing System
 *
 * OpenAPI spec version: v1
 * Contact: support@ish.com.au
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

export const createStringEnum = <T extends string>(o: Array<T>): {[K in T]: K} => {
  return o.reduce((res, key) => {
    res[key] = key;
    return res;
  }, Object.create(null));
};

/**
* 
* @export
* @class AdobeSettings
*/
export class AdobeSettings {
  /**
  * 
  * @type {string}
  * @memberof AdobeSettings
  */
  analyticsUrl?: string;
}

export const AutomationStatus = createStringEnum([
  'Not Installed',
  'Installed but Disabled',
  'Enabled',
  'Hidden',
]);

export type AutomationStatus = keyof typeof AutomationStatus;


export const BillingPlan = createStringEnum([
  'starter-21',
  'basic-21',
  'premium-21',
]);

export type BillingPlan = keyof typeof BillingPlan;
/**
* 
* @export
* @class Binding
*/
export class Binding {
  /**
  * variable name in script/export body
  * @type {string}
  * @memberof Binding
  */
  name?: string;
  /**
  * Display label on user dialog on share menu
  * @type {string}
  * @memberof Binding
  */
  label?: string;
  /**
  * 
  * @type {DataType}
  * @memberof Binding
  */
  type?: DataType;
  /**
  * value for binding, used on setting up for Options only
  * @type {string}
  * @memberof Binding
  */
  value?: string;
  /**
  * internal automation bindings
  * @type {boolean}
  * @memberof Binding
  */
  system?: boolean;
  /**
  * defaul value for system binding
  * @type {string}
  * @memberof Binding
  */
  valueDefault?: string;
}/**
* 
* @export
* @class College
*/
export class College {
  /**
  * college sub domain
  * @type {string}
  * @memberof College
  */
  collegeKey?: string;
  /**
  * College name
  * @type {string}
  * @memberof College
  */
  organisationName?: string;
  /**
  * College abn
  * @type {string}
  * @memberof College
  */
  abn?: string;
  /**
  * College traiding name
  * @type {string}
  * @memberof College
  */
  tradingName?: string;
  /**
  * College address
  * @type {string}
  * @memberof College
  */
  address?: string;
  /**
  * College suburb
  * @type {string}
  * @memberof College
  */
  suburb?: string;
  /**
  * College state
  * @type {string}
  * @memberof College
  */
  state?: string;
  /**
  * College postcode
  * @type {string}
  * @memberof College
  */
  postcode?: string;
  /**
  * College country
  * @type {string}
  * @memberof College
  */
  country?: string;
  /**
  * College time zone
  * @type {string}
  * @memberof College
  */
  timeZone?: string;
  /**
  * user email
  * @type {string}
  * @memberof College
  */
  userEmail?: string;
  /**
  * user first name
  * @type {string}
  * @memberof College
  */
  userFirstName?: string;
  /**
  * user last name
  * @type {string}
  * @memberof College
  */
  userLastName?: string;
  /**
  * user phone number
  * @type {string}
  * @memberof College
  */
  userPhone?: string;
  /**
  * 
  * @type {SiteTemplate}
  * @memberof College
  */
  webSiteTemplate?: SiteTemplate;
  /**
  * 
  * @type {Currency}
  * @memberof College
  */
  currency?: Currency;
}

export const Currency = createStringEnum([
  'us',
  'aud',
  'nz',
  'eu',
]);

export type Currency = keyof typeof Currency;


export const DataType = createStringEnum([
  'Text',
  'Long text',
  'Pattern text',
  'List',
  'Map',
  'Date',
  'Date time',
  'Checkbox',
  'Record',
  'File',
  'Money',
  'Message template',
  'URL',
  'Email',
  'Object',
  'Number',
  'Portal subdomain',
]);

export type DataType = keyof typeof DataType;
/**
* 
* @export
* @class ModelError
*/
export class ModelError {
  /**
  * Error description
  * @type {string}
  * @memberof ModelError
  */
  message?: string;
}/**
* 
* @export
* @class PortalWebsite
*/
export class PortalWebsite {
  /**
  * Unique portal instance identifier
  * @type {number}
  * @memberof PortalWebsite
  */
  id?: number;
  /**
  * Portal site title
  * @type {string}
  * @memberof PortalWebsite
  */
  websiteName?: string;
  /**
  * Color for primary interface elements
  * @type {string}
  * @memberof PortalWebsite
  */
  websitePrimaryColor?: string;
  /**
  * Sub domain needed to separate different types of college clients across different websites
  * @type {string}
  * @memberof PortalWebsite
  */
  subDomain?: string;
  /**
  * Website logo encoded in base64 format to display preview in App
  * @type {string}
  * @memberof PortalWebsite
  */
  websiteLogo?: string;
  /**
  * Logo name
  * @type {string}
  * @memberof PortalWebsite
  */
  websiteLogoName?: string;
  /**
  * 
  * @type {boolean}
  * @memberof PortalWebsite
  */
  isDefault?: boolean;
  /**
  * The student can see tutor notes by default on a new portal
  * @type {boolean}
  * @memberof PortalWebsite
  */
  tutorNotesVisibleByDefault?: boolean;
  /**
  * The tutor might be able to see the email and phone details for the students
  * @type {boolean}
  * @memberof PortalWebsite
  */
  hideStudentDetails?: boolean;
  /**
  * The tutor can mark outcomes for VET training
  * @type {boolean}
  * @memberof PortalWebsite
  */
  enableOutcomeMarking?: boolean;
  /**
  * Address to which replies from tutors will be sent.
  * @type {string}
  * @memberof PortalWebsite
  */
  tutorFeedbackEmail?: string;
  /**
  * 
  * @type {number}
  * @memberof PortalWebsite
  */
  reportAngelId?: number;
  /**
  * 
  * @type {number}
  * @memberof PortalWebsite
  */
  reportOverlayAngelId?: number;
}/**
* 
* @export
* @class PortalWebsiteRequest
*/
export class PortalWebsiteRequest {
  /**
  * Unique portal instance identifier
  * @type {number}
  * @memberof PortalWebsiteRequest
  */
  id?: number;
  /**
  * Portal site title
  * @type {string}
  * @memberof PortalWebsiteRequest
  */
  websiteName?: string;
  /**
  * Color for primary interface elements
  * @type {string}
  * @memberof PortalWebsiteRequest
  */
  websitePrimaryColor?: string;
  /**
  * Sub domain needed to separate different types of college clients across different websites
  * @type {string}
  * @memberof PortalWebsiteRequest
  */
  subDomain?: string;
  /**
  * Website logo encoded as File
  * @type {Blob}
  * @memberof PortalWebsiteRequest
  */
  websiteLogo?: Blob;
  /**
  * Logo name
  * @type {string}
  * @memberof PortalWebsiteRequest
  */
  websiteLogoName?: string;
  /**
  * default value of tutor notes visibility on a new portal. True by default
  * @type {boolean}
  * @memberof PortalWebsiteRequest
  */
  tutorNotesVisibleByDefault?: boolean;
  /**
  * The tutor might be able to see the email and phone details for the students
  * @type {boolean}
  * @memberof PortalWebsiteRequest
  */
  hideStudentDetails?: boolean;
  /**
  * The tutor can mark outcomes for VET training
  * @type {boolean}
  * @memberof PortalWebsiteRequest
  */
  enableOutcomeMarking?: boolean;
  /**
  * Address to which replies from tutors will be sent.
  * @type {string}
  * @memberof PortalWebsiteRequest
  */
  tutorFeedbackEmail?: string;
  /**
  * 
  * @type {number}
  * @memberof PortalWebsiteRequest
  */
  angelReportId?: number;
  /**
  * 
  * @type {number}
  * @memberof PortalWebsiteRequest
  */
  angelReportOverlayId?: number;
}/**
* 
* @export
* @class Properties
*/
export class Properties {
  /**
  * client id from application properties
  * @type {string}
  * @memberof Properties
  */
  googleClientId?: string;
  /**
  * 
  * @type {number}
  * @memberof Properties
  */
  portalLogoMaxSize?: number;
  /**
  * A `custom_logo_black` property value from the onCourse.yml configuration for the
  * @type {string}
  * @memberof Properties
  */
  customLogoBlack?: string;
  /**
  * A `custom_logo_colour` property value from the onCourse.yml configuration for the
  * @type {string}
  * @memberof Properties
  */
  customLogoColour?: string;
}/**
* 
* @export
* @class PublicProperties
*/
export class PublicProperties {
  /**
  * A `custom_logo_black` property value from the application.properties Billing configuration
  * @type {string}
  * @memberof PublicProperties
  */
  customLogoBlack?: string;
  /**
  * A `custom_colour_black` property value from the application.properties Billing configuration
  * @type {string}
  * @memberof PublicProperties
  */
  customLogoColour?: string;
}/**
* report object
* @export
* @class Report
*/
export class Report {
  /**
  * 
  * @type {number}
  * @memberof Report
  */
  id?: number;
  /**
  * 
  * @type {string}
  * @memberof Report
  */
  name?: string;
  /**
  * 
  * @type {string}
  * @memberof Report
  */
  entity?: string;
  /**
  * 
  * @type {AutomationStatus}
  * @memberof Report
  */
  status?: AutomationStatus;
  /**
  * 
  * @type {string}
  * @memberof Report
  */
  keyCode?: string;
  /**
  * 
  * @type {string}
  * @memberof Report
  */
  description?: string;
  /**
  * 
  * @type {string}
  * @memberof Report
  */
  body?: string;
  /**
  * 
  * @type {number}
  * @memberof Report
  */
  backgroundId?: number;
  /**
  * sorting attribyte
  * @type {string}
  * @memberof Report
  */
  sortOn?: string;
  /**
  * 
  * @type {Array<Binding>}
  * @memberof Report
  */
  variables?: Array<Binding>;
  /**
  * 
  * @type {Array<Binding>}
  * @memberof Report
  */
  options?: Array<Binding>;
  /**
  * Message template short description
  * @type {string}
  * @memberof Report
  */
  shortDescription?: string;
  /**
  * automation tags separated by commas
  * @type {string}
  * @memberof Report
  */
  automationTags?: string;
  /**
  * automation category
  * @type {string}
  * @memberof Report
  */
  category?: string;
}/**
* report overlay object
* @export
* @class ReportOverlay
*/
export class ReportOverlay {
  /**
  * 
  * @type {number}
  * @memberof ReportOverlay
  */
  id?: number;
  /**
  * 
  * @type {string}
  * @memberof ReportOverlay
  */
  name?: string;
}/**
* 
* @export
* @class Settings
*/
export class Settings {
  /**
  * contact full name information
  * @type {string}
  * @memberof Settings
  */
  contactFullName?: string;
  /**
  * contact email information
  * @type {string}
  * @memberof Settings
  */
  contactEmail?: string;
  /**
  * licensed concurrent users count
  * @type {string}
  * @memberof Settings
  */
  invoiceReference?: string;
  /**
  * licensed concurrent users count
  * @type {number}
  * @memberof Settings
  */
  usersCount?: number;
  /**
  * 
  * @type {BillingPlan}
  * @memberof Settings
  */
  billingPlan?: BillingPlan;
  /**
  * 
  * @type {number}
  * @memberof Settings
  */
  requestedUsersCount?: number;
  /**
  * 
  * @type {BillingPlan}
  * @memberof Settings
  */
  requestedBillingPlan?: BillingPlan;
  /**
  * 
  * @type {boolean}
  * @memberof Settings
  */
  reportsConfigured?: boolean;
}/**
* 
* @export
* @class Site
*/
export class Site {
  /**
  * 
  * @type {number}
  * @memberof Site
  */
  id?: number;
  /**
  * 
  * @type {string}
  * @memberof Site
  */
  key?: string;
  /**
  * 
  * @type {string}
  * @memberof Site
  */
  name?: string;
  /**
  * 
  * @type {string}
  * @memberof Site
  */
  googleAnalyticsId?: string;
  /**
  * 
  * @type {AdobeSettings}
  * @memberof Site
  */
  adobeSettings?: AdobeSettings;
  /**
  * 
  * @type {string}
  * @memberof Site
  */
  gtmAccountId?: string;
  /**
  * 
  * @type {string}
  * @memberof Site
  */
  gtmContainerId?: string;
  /**
  * 
  * @type {string}
  * @memberof Site
  */
  googleRecaptchaKey?: string;
  /**
  * google reCAPTCHA version, v2 (checkbox) or v3 (invisible, score based)
  * @type {string}
  * @memberof Site
  */
  recaptchaVersion?: string;
  /**
  * 
  * @type {string}
  * @memberof Site
  */
  recaptchaSecretKey?: string;
  /**
  * 
  * @type {number}
  * @memberof Site
  */
  recaptchaMinScore?: number;
  /**
  * 
  * @type {SiteTemplate}
  * @memberof Site
  */
  webSiteTemplate?: SiteTemplate;
  /**
  * map where keys are domains, values are errors if some of this domain ip addresses are not in range
  * @type {{ [key: string]: string; }}
  * @memberof Site
  */
  domains?: { [key: string]: string; };
  /**
  * primary web site domain
  * @type {string}
  * @memberof Site
  */
  primaryDomain?: string;
  /**
  * 
  * @type {UserInfo}
  * @memberof Site
  */
  configuredByInfo?: UserInfo;
  /**
  * tag ids by which it is possible to display in the web only courses atached to the tag
  * @type {Array<number>}
  * @memberof Site
  */
  rootTags?: Array<number>;
}

export const SiteTemplate = createStringEnum([
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
]);

export type SiteTemplate = keyof typeof SiteTemplate;
/**
* 
* @export
* @class Tag
*/
export class Tag {
  /**
  * Unique identifier for tag
  * @type {number}
  * @memberof Tag
  */
  id?: number;
  /**
  * 
  * @type {string}
  * @memberof Tag
  */
  name: string;
  /**
  * 
  * @type {string}
  * @memberof Tag
  */
  color?: string;
  /**
  * 
  * @type {number}
  * @memberof Tag
  */
  weight?: number;
  /**
  * 
  * @type {number}
  * @memberof Tag
  */
  childrenCount: number;
  /**
  * 
  * @type {Array<TagGroupRequirement>}
  * @memberof Tag
  */
  requirements?: Array<TagGroupRequirement>;
  /**
  * 
  * @type {Array<Tag>}
  * @memberof Tag
  */
  childTags?: Array<Tag>;
  /**
  * date and time when record was created
  * @type {string}
  * @memberof Tag
  */
  created?: string;
  /**
  * date and time when record was modified
  * @type {string}
  * @memberof Tag
  */
  modified?: string;
}/**
* 
* @export
* @class TagGroupRequirement
*/
export class TagGroupRequirement {
  /**
  * Unique identifier
  * @type {number}
  * @memberof TagGroupRequirement
  */
  id?: number;
  /**
  * type
  * @type {string}
  * @memberof TagGroupRequirement
  */
  entityIdentifier: string;
  /**
  * 
  * @type {boolean}
  * @memberof TagGroupRequirement
  */
  mandatory: boolean;
  /**
  * 
  * @type {boolean}
  * @memberof TagGroupRequirement
  */
  limitToOneTag: boolean;
}/**
* 
* @export
* @class UserInfo
*/
export class UserInfo {
  /**
  * system user's first name
  * @type {string}
  * @memberof UserInfo
  */
  firstname?: string;
  /**
  * system user's last name
  * @type {string}
  * @memberof UserInfo
  */
  lastname?: string;
  /**
  * User's email
  * @type {string}
  * @memberof UserInfo
  */
  email?: string;
}
export class BillingApi {

    constructor(private http: any) {}

    createCollege(body: College): Promise<any> {
      return this.http.POST('/v1/college/', body, { headers: {}, params: {}, responseType: '' });
    }

    getCollegeKey(): Promise<string> {
      return this.http.GET('/v1/college/key', { headers: {}, params: {}, responseType: '' });
    }

    verifyCollegeName(collegeKey: string, xGRecaptcha: string): Promise<boolean> {
      return this.http.GET(`/v1/college/${collegeKey}`, { headers: { xGRecaptcha }, params: {}, responseType: '' });
    }
}

export class PortalWebsiteApi {

    constructor(private http: any) {}

    deletePortalWebsite(id: number): Promise<any> {
      return this.http.DELETE(`/v1/college/portal/website/${id}`, { headers: {}, params: {}, responseType: '' });
    }

    getPortalWebsites(): Promise<Array<PortalWebsite>> {
      return this.http.GET('/v1/college/portal/website/', { headers: {}, params: {}, responseType: '' });
    }

    updatePortalWebsite(id: number, websiteName: string, websitePrimaryColor: string, subDomain: string, websiteLogo: Blob, websiteLogoName: string, tutorNotesVisibleByDefault: boolean, hideStudentDetails: boolean, enableOutcomeMarking: boolean, tutorFeedbackEmail: string, angelReportId: number, angelReportOverlayId: number): Promise<any> {
      const body = new FormData();
      if (id !== undefined) {
        body.set('id', id as any);
      }
      if (websiteName !== undefined) {
        body.set('websiteName', websiteName as any);
      }
      if (websitePrimaryColor !== undefined) {
        body.set('websitePrimaryColor', websitePrimaryColor as any);
      }
      if (subDomain !== undefined) {
        body.set('subDomain', subDomain as any);
      }
      if (websiteLogo !== undefined) {
        body.set('websiteLogo', websiteLogo as any);
      }
      if (websiteLogoName !== undefined) {
        body.set('websiteLogoName', websiteLogoName as any);
      }
      if (tutorNotesVisibleByDefault !== undefined) {
        body.set('tutorNotesVisibleByDefault', tutorNotesVisibleByDefault as any);
      }
      if (hideStudentDetails !== undefined) {
        body.set('hideStudentDetails', hideStudentDetails as any);
      }
      if (enableOutcomeMarking !== undefined) {
        body.set('enableOutcomeMarking', enableOutcomeMarking as any);
      }
      if (tutorFeedbackEmail !== undefined) {
        body.set('tutorFeedbackEmail', tutorFeedbackEmail as any);
      }
      if (angelReportId !== undefined) {
        body.set('angelReportId', angelReportId as any);
      }
      if (angelReportOverlayId !== undefined) {
        body.set('angelReportOverlayId', angelReportOverlayId as any);
      }
      return this.http.POST('/v1/college/portal/website/', body, { headers: { 'Content-Type': '`multipart/form-data`' }, params: {}, responseType: '' });
    }
}

export class PropertiesApi {

    constructor(private http: any) {}

    getProperties(): Promise<Properties> {
      return this.http.GET('/v1/properties', { headers: {}, params: {}, responseType: '' });
    }

    getPublicProperties(): Promise<PublicProperties> {
      return this.http.GET('/v1/properties/public', { headers: {}, params: {}, responseType: '' });
    }
}

export class ReportApi {

    constructor(private http: any) {}

    getAllFromAngel(): Promise<Array<Report>> {
      return this.http.GET('/v1/college/portal/reports', { headers: {}, params: {}, responseType: '' });
    }

    getOverlaysFromAngel(): Promise<Array<ReportOverlay>> {
      return this.http.GET('/v1/college/portal/reports/overlays', { headers: {}, params: {}, responseType: '' });
    }

    getPreview(id: number): Promise<string> {
      return this.http.GET(`/v1/college/portal/reports/${id}/preview`, { headers: {}, params: {}, responseType: '' });
    }
}

export class SettingsApi {

    constructor(private http: any) {}

    getSettings(): Promise<Settings> {
      return this.http.GET('/v1/college/settings', { headers: {}, params: {}, responseType: '' });
    }

    getTags(): Promise<Array<Tag>> {
      return this.http.GET('/v1/college/settings/tag', { headers: {}, params: {}, responseType: '' });
    }

    updateSettings(body: Settings): Promise<any> {
      return this.http.POST('/v1/college/settings', body, { headers: {}, params: {}, responseType: '' });
    }
}

export class WebSiteApi {

    constructor(private http: any) {}

    createSite(body: Site): Promise<any> {
      return this.http.POST('/v1/college/site', body, { headers: {}, params: {}, responseType: '' });
    }

    deleteSite(id: number): Promise<any> {
      return this.http.DELETE(`/v1/college/site/${id}`, { headers: {}, params: {}, responseType: '' });
    }

    getSites(): Promise<Array<Site>> {
      return this.http.GET('/v1/college/site', { headers: {}, params: {}, responseType: '' });
    }

    updateSite(body: Site): Promise<any> {
      return this.http.PUT('/v1/college/site', body, { headers: {}, params: {}, responseType: '' });
    }
}


